import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { VendorLgaMap } from "@/components/VendorLgaMap";
import { STATE_COORDS } from "@/pages/FindVendor";

export const NearbyShops = ({ state }) => {
  const [vendors, setVendors] = useState(null);
  useEffect(() => {
    api.get("/vendors", { params: state ? { state } : {} }).then(({ data }) => setVendors(data.vendors)).catch(() => setVendors([]));
  }, [state]);
  if (!vendors) return null;
  return (
    <div className="mt-8 rounded-3xl border border-emerald-100 bg-white p-6" data-testid="nearby-shops-card">
      <div className="flex flex-wrap items-end justify-between gap-2 mb-4">
        <div>
          <h3 className="font-display font-bold text-lg text-emerald-950">TMF shops near you</h3>
          <p className="text-sm text-gray-600">{state ? `Approved shops in ${state}.` : "Approved TMF shops."} Tap a circle to see the shops in that LGA and call them.</p>
        </div>
        <Link to="/find-vendor" className="text-sm text-emerald-700 underline" data-testid="nearby-shops-all-link">Search all vendors</Link>
      </div>
      {vendors.length ? <VendorLgaMap vendors={vendors} stateCoords={STATE_COORDS} height={360} />
        : <p className="text-sm text-gray-500" data-testid="nearby-shops-empty">No approved shops in {state} yet.</p>}
    </div>
  );
};
